/**
 * Nominee Data Model
 * Based on PACE Guardianship and Nominee specifications
 */

export const createNominee = (data = {}) => {
  return {
    id: data.id || null,
    participantId: data.participantId || null,
    
    // Personal Information
    firstName: data.firstName || '',
    lastName: data.lastName || '',
    dateOfBirth: data.dateOfBirth || null,
    relationship: data.relationship || '', // e.g., "Parent", "Guardian", "Legal Representative"
    
    // Contact
    phone: data.phone || null,
    email: data.email || null,
    address: data.address || null,
    
    // Nominee Type
    nomineeType: data.nomineeType || null, // Plan Nominee, Correspondence Nominee, Court Appointed Guardian
    
    // Authentication
    authTokenId: data.authTokenId || null, // PRODA authentication token
    prodaUsername: data.prodaUsername || null,
    
    // Authority Scope
    authorityScope: data.authorityScope || {
      financialLimit: 'unlimited', // 'unlimited' or dollar amount
      serviceBookingAccess: true,
      planDetailsAccess: true,
      budgetAccess: true,
      claimsAccess: true,
      clinicalNotesAccess: false,
      restrictions: [] // Array of specific restrictions
    },
    
    // Status
    status: data.status || 'active', // active, inactive, suspended
    startDate: data.startDate || null,
    endDate: data.endDate || null,
    
    // Court Orders (for Court Appointed Guardian)
    courtOrder: data.courtOrder || null,
    courtOrderDate: data.courtOrderDate || null,
    courtOrderNumber: data.courtOrderNumber || null,
    
    // Metadata
    createdAt: data.createdAt || new Date().toISOString(),
    updatedAt: data.updatedAt || new Date().toISOString(),
    createdBy: data.createdBy || null
  };
};

export const NOMINEE_TYPES = {
  PLAN_NOMINEE: 'Plan Nominee',
  CORRESPONDENCE_NOMINEE: 'Correspondence Nominee',
  COURT_APPOINTED_GUARDIAN: 'Court Appointed Guardian'
};

export const NOMINEE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended'
};

export const validateNominee = (nominee) => {
  const errors = [];
  
  if (!nominee.firstName || !nominee.lastName) {
    errors.push('Name is required');
  }
  
  if (!nominee.nomineeType) {
    errors.push('Nominee type is required');
  }
  
  if (!Object.values(NOMINEE_TYPES).includes(nominee.nomineeType)) {
    errors.push('Invalid nominee type');
  }
  
  if (nominee.nomineeType === NOMINEE_TYPES.COURT_APPOINTED_GUARDIAN && !nominee.courtOrder) {
    errors.push('Court order is required for Court Appointed Guardian');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

